/* eslint-disable arrow-body-style */
import React from 'react';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Popover } from '@abyss/web/ui/Popover';

export const RiskScoresTableHead = () => {
  const headers = [
    { label: 'TIN' },
    { label: 'Risk Severity' },
    {
      label: 'Risk Score',
      popoverContent:
        'Risk Score is calculated by aggregating values from multiple signals. Each signal contributes an individual score, and these are summed to produce a total risk score.',
    },
    {
      label: 'Risk Activity',
      popoverContent:
        'Risk Activity shows when the last new signal was detected and incorporated into the Risk Score. This may correspond to an increase in the Risk Score.',
    },
  ];
  return (
    <thead>
      <tr>
        {headers.map((header) => (
          <th key={header.label}>
            <div className="with-icon">
              <span>{header.label}</span>
              {header.popoverContent && (
                <Popover content={header.popoverContent} position="top">
                  <IconSymbol icon="info" variant="fill" />
                </Popover>
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};
